export type AdvancedSearchDateRangeFilter = {
  field: 'date_shipped';
  start: number;
  end?: number;
};

export interface AdvancedSearchFiltersController {
  getCourier: () => string;
  getStage: () => string;
  getDateRangeFilter: () => AdvancedSearchDateRangeFilter | undefined;
  reset: () => void;
}

declare global {
  interface Window {
    AdvancedSearchFiltersController?: AdvancedSearchFiltersController;
  }
}

export function registerAdvancedSearchFiltersController(controller: AdvancedSearchFiltersController): void {
  window.AdvancedSearchFiltersController = controller;
}

export function unregisterAdvancedSearchFiltersController(controller: AdvancedSearchFiltersController): void {
  if (window.AdvancedSearchFiltersController === controller) {
    delete window.AdvancedSearchFiltersController;
  }
}
